import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../services/authContext';
import { arisanService, userService } from '../services/api';
import './ArisanPages.css';

const CreateArisanPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    monthlyAmount: '',
    startDate: '',
    cycle: '12',
    memberIds: []
  });
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoadingUsers(true);
      const response = await userService.getAllUsers();
      // Show all users except current user (creator is auto-added in backend)
      const allUsers = response.data.filter(u => u._id !== user?.id);
      setUsers(allUsers);
      console.log('Loaded users:', allUsers.length);
    } catch (err) {
      console.error('Error fetching users:', err);
      setError('Gagal memuat daftar pengguna: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleMemberToggle = (userId) => {
    setFormData(prev => ({
      ...prev,
      memberIds: prev.memberIds.includes(userId)
        ? prev.memberIds.filter(id => id !== userId)
        : [...prev.memberIds, userId]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await arisanService.create(formData);
      navigate('/arisans');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create arisan');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-content">
        <h2>Buat Arisan Baru</h2>
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit} className="arisan-form">
          <div className="form-group">
            <label>Nama Arisan *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Deskripsi</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="3"
            ></textarea>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Iuran Bulanan *</label>
              <input
                type="number"
                name="monthlyAmount"
                value={formData.monthlyAmount}
                onChange={handleChange}
                required
                min="1"
              />
            </div>

            <div className="form-group">
              <label>Tanggal Mulai *</label>
              <input
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Siklus (bulan) *</label>
              <input
                type="number"
                name="cycle"
                value={formData.cycle}
                onChange={handleChange}
                min="1"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Tambah Anggota</label>
            {loadingUsers ? (
              <p>Memuat daftar anggota...</p>
            ) : users.length === 0 ? (
              <p className="info-message">Belum ada pengguna lain yang terdaftar. Anda akan menjadi satu-satunya anggota arisan ini.</p>
            ) : (
              <div className="members-list">
                <p className="helper-text">Pilih anggota yang akan dimasukkan ke arisan (Anda otomatis menjadi anggota):</p>
                {users.map(member => (
                  <label key={member._id} className="member-checkbox">
                    <input
                      type="checkbox"
                      checked={formData.memberIds.includes(member._id)}
                      onChange={() => handleMemberToggle(member._id)}
                    />
                    <span>{member.name} ({member.email})</span>
                  </label>
                ))}
                <p className="helper-text">Total anggota terpilih: {formData.memberIds.length + 1} (termasuk Anda)</p>
              </div>
            )}
          </div>

          <div className="form-actions">
            <button type="submit" disabled={loading} className="btn-submit">
              {loading ? 'Membuat...' : 'Buat Arisan'}
            </button>
            <button type="button" onClick={() => navigate('/arisans')} className="btn-cancel">
              Batal
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateArisanPage;
